module.exports = __webpack_public_path__ + "img/gateway-usdttrc20-logo.249ca66f.svg";